<template>
    <div :class="$style.wrapper" class='fs24' ref="root">
        <div class="center fs18" style="padding-top: 10px;margin-bottom: 30px;">
            <p class="black fs32 fw500 showInLargeb">{{ $t('resume') }}</p>
            <div class="showInSmallf left">
                <p>{{$t('resume')}}</p>
                <p style="margin-left: 10px;" @click="backToList">{{ $t('back') }}</p>
                <div class="f1"></div>
                <!-- <el-link type="primary" class="mr20" @click="share">{{ $t('share') }}</el-link> -->
                <!-- <el-dropdown class="mr20" style="vertical-align: 1px;" @command="handleCommand">
                <span class="el-dropdown-link yel">
                    {{$t('share')}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="washare">WhatsApp</el-dropdown-item>
                    <el-dropdown-item command="share">Facebook</el-dropdown-item>
                </el-dropdown-menu>
                </el-dropdown> -->
                <el-dropdown class="mr20" style="vertical-align: 1px;" @command="handleCommand">
                    <span class="el-dropdown-link yel">
                        {{$t('share')}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="washare">WhatsApp</el-dropdown-item>
                        <el-dropdown-item command="share">Facebook</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-link type="primary" class="mr20" @click="print">{{ $t('print') }}</el-link>
                <el-link type="primary" class="mr20" @click="pdf">{{ $t('export') }}</el-link>
            </div>
        </div>
        <div class="right fs24 showInLargeb print" style="margin-bottom: 50px;">
            <!-- <el-link type="primary" class="mr20" @click="share">{{ $t('share') }}</el-link> -->
            <el-dropdown class="mr20" style="vertical-align: 1px;" @command="handleCommand">
                <span class="el-dropdown-link yel">
                    {{$t('share')}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="washare">WhatsApp</el-dropdown-item>
                    <el-dropdown-item command="share">Facebook</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-link type="primary" class="mr20" @click="print">{{ $t('print') }}</el-link>
            <el-link type="primary" @click="pdf">{{ $t('export') }}</el-link>
        </div>
		<!-- 将youtube视频和加入面试预约 置入头部屏幕中间 -->
		<div class="dflex fc" style="text-align: center;" :class="$style.rightb">
			<p>
				<ubutton v-if="item.youtube_video_link" :text="$t('pff41')" :href="item.youtube_video_link" style="margin-bottom: 10px;"></ubutton>
			</p>
			<p>
				<el-button v-if="isChecked" type="warning" round @click="onClickFavorite">{{ interName }}</el-button>	
				<el-button v-else  round @click="onClickFavorite">{{ interName }}</el-button>
			</p>
			<reminderDialogVue :close="closeDialog" :p="reminderMsg" :requiredDialogVisible.sync = "requiredDialogVisible"></reminderDialogVue>
		</div>
        <div class="dflex showInLargef" :class="$style.pic">
            <div class="mr20 dflex fc" style="width:10%;">
                <img v-for="p in pics" :key="p" :src="item[p]" alt="" @click="selectedImg = p" style="margin-bottom: 10px;" class="cp" width="100%">
            </div>
            <div style="margin: 0px 40px;width:30%;">
                <img :src="item[selectedImg]" alt="" style="height: 700px;" width="100%">
            </div>
            <div style="line-height: 1.8;padding-left: 20px;margin-left:30px;" class="f1">
                <p v-for="item in list" :key="item.label" class="dflex" style="margin-bottom: 1.25rem;">
                    <span class="f1 gray">{{item.label}}</span><span class="gray">:</span>
                    <span style="flex: 2;padding-left: 20px;">{{item.value}}</span>
                </p>
            </div>
        </div>
        <div class="dflex showInSmallf fc" :class="$style.pic">
            <div class="dflex">
                <div class="mr20 dflex fc" style="width:30%;">
                    <img v-for="p in pics" :key="p" :src="item[p]" alt="" @click="selectedImg = p" style="margin-bottom: 10px;" class="cp" width="75%">
                </div>
                <div :class="$style.picm">
                    <img :src="item[selectedImg]" alt="" width="100%">
                </div>
            </div>
            <div style="line-height: 1.8;margin-top:30px;" class="dflex fw">
                <p v-for="item in mobileList" :key="item.label" class="dflex" style="width: 50%;">
                    <!-- 第一第二第三喜爱要竖着排列，在移动端 -->
                    <span v-if="item.value === null"></span>
                    <template v-else>
                        <span class="f1 gray">{{item.label}}</span><span class="gray">:</span>
                        <span style="flex: 2;padding-left: 20px;">{{item.value}}</span>
                    </template>
                </p>
            </div>
        </div>
        <div >
            <h2>{{$t('pff3')}}</h2>
            <template v-if="item['new_working_experiences'] && item['new_working_experiences'].length > 0">
                <div v-for="expe in item['new_working_experiences']" :key="expe.from_date" style="margin-bottom: 20px;">
                    <p>{{expe.location + " ( " + format(new Date(expe.from_date), "MMM yyyy") + " - " + format(new Date(expe.to_date), "MMM yyyy") + " ) " + expe.position + ", " + expe.industry}}</p>
                    <p>{{expe.job_description}}</p>
                </div>
            </template>
            <div v-else v-html="item['working_experiences']"></div>
        </div>
        <div class="dflex showInLargef">
            <div class="f1" :class="$style.leftb">
                <h2>{{$t('pff4')}}</h2>
                <div class="dflex" :class="$style.lang" style="margin-bottom: 10px;">
                    <p style="width: 25%;"></p>
                    <p style="width: 25%;">Don't know</p>
                    <p style="width: 25%;">Fair</p>
                    <p style="width: 25%;">Good</p>
                </div>
                <div v-for="lang in item.language" :key="lang.id" :class="$style.lang" class="dflex">
                    <p>{{lang.language}}</p>
                    <p>
                        <img src="../assets/yes.png" alt="" v-if="lang['master_degree'].toLowerCase() === `don't know`">
                        <img v-else src="../assets/no.png" alt="">
                    </p>
                    <p>
                        <img src="../assets/yes.png" alt="" v-if="lang['master_degree'].toLowerCase() === 'fair'">
                        <img v-else src="../assets/no.png" alt="">
                    </p>
                    <p>
                        <img src="../assets/yes.png" alt="" v-if="lang['master_degree'].toLowerCase() === 'good'">
                        <img v-else src="../assets/no.png" alt="">
                    </p>
                </div>
            </div>
            <!-- <div class="f1 dflex fc" :class="$style.rightb">
                <p class="f1"></p>
                <ubutton v-if="item.youtube_video_link" :text="$t('pff41')" :href="item.youtube_video_link" style="margin-bottom: 10px;"></ubutton>
            </div> -->
        </div>
        <div class="showInSmallb">
            <h2>{{$t('pff4')}}</h2>
            <div class="dflex" :class="$style.lang" style="margin-bottom:10px;">
                <p style="width: 25%;"></p>
                <p style="width: 25%;">Don't know</p>
                <p style="width: 25%;">Fair</p>
                <p style="width: 25%;">Good</p>
            </div>
            <div v-for="lang in item.language" :key="lang.id" :class="$style.lang" class="dflex">
                <p>{{lang.language}}</p>
                <p>
                    <img src="../assets/yes.png" alt="" v-if="lang['master_degree'].toLowerCase() === `don't know`">
                    <img v-else src="../assets/no.png" alt="">
                </p>
                <p>
                    <img src="../assets/yes.png" alt="" v-if="lang['master_degree'].toLowerCase() === 'fair'">
                    <img v-else src="../assets/no.png" alt="">
                </p>
                <p>
                    <img src="../assets/yes.png" alt="" v-if="lang['master_degree'].toLowerCase() === 'good'">
                    <img v-else src="../assets/no.png" alt="">
                </p>
            </div>
            <!-- <div v-if="item.youtube_video_link" style="margin-top:20px;">
                <ubutton :text="$t('pff41')" :href="item.youtube_video_link" style="margin-bottom: 10px;"></ubutton>
            </div> -->
        </div>
        <div class="dflex">
			
            <!-- <div class="f1" style="margin-right: 25px;">
                <h2>{{ $t('pff5') }}</h2>
                <p class="dflex">
                    <span>{{ $t('pff6') }}</span>
                    <span class="f1 right">{{ item.remark['serious_sick_before'] }}</span>
                </p>
                <p class="dflex">
                    <span>{{ $t('pff7') }}</span>
                    <span class="f1 right">{{ item.remark['mental_issue'] }}</span>
                </p>
                <p class="dflex">
                    <span>{{ $t('pff8') }}</span>
                    <span class="f1 right">{{ item.remark['high_blood'] }}</span>
                </p>
                <p class="dflex">
                    <span>{{ $t('pff9') }}</span>
                    <span class="f1 right">{{ item.remark['lung_disease'] }}</span>
                </p>
                <p class="dflex">
                    <span>{{ $t('pff10') }}</span>
                    <span class="f1 right">{{ item.remark['smoking'] }}</span>
                </p>
                <p class="dflex">
                    <span>{{ $t('pff101') }}</span>
                    <span class="f1 right">{{ item.remark['skin_allergy'] }}</span>
                </p>
                <p class="dflex">
                    <span>{{ $t('pff11') }}</span>
                    <span class="f1 right">{{ item.remark['tattoo'] }}</span>
                </p>
            </div> -->
            <div class="f1" :class="$style.rightb">
                <h2>{{ $t('pff12') }}</h2>
                <p>{{$t('pff13')}} : {{item.family['farther_name']}}</p>
                <p>{{$t('pff14')}} : {{item.family['mother_name']}}</p>
                <p>{{$t('pff15')}} : {{item.family['brother_or_sister_no']}}</p>
                <p>{{$t('pff16')}} : {{item.family['home_address']}}</p>
                <p>{{$t('pff17')}} : {{item.family['city']}}</p>
                <p>{{$t('pff18')}} : {{item.family['province']}}</p>
                <p>{{$t('pff181')}} : {{item.family['postal_code']}}</p>
            </div>
        </div>
        <div class="dflex">
            <div class="f1" :class="$style.leftb">
                <h2>{{ $t('pff5') }}</h2>
                <p>{{$t('pff19')}} : {{item.remark['height']}} CM</p>
                <p>{{$t('pff20')}} : {{item.remark['weight']}} KG</p>
            </div>
            <div class="f1" :class="$style.rightb">
                <p class="mb30">
                    <span>{{ $t('status') }}</span>
                    <span :class="$style.state" :notavail="!item['available_status']" class="white fs18" style="padding: 0px 10px;border-radius: 5px;margin-left: 40px;">{{!!item['available_status'] ? $t('available') : $t('notavailable')}}</span>
                </p>
                <p>
					
                    <!-- <img :src="hearturl" width="24" class="cp" @click="onClickFavorite" :class="$style.heart" @mouseover="hoverHeart = true" @mouseout="hoverHeart = false">
                    <span>{{$t('favorite')}}</span> -->

					<!-- <el-checkbox-button :label="interName" v-model="isChecked" @change="onClickFavorite" ></el-checkbox-button> -->
					<el-button v-if="isChecked" type="warning" round @click="onClickFavorite">{{ interName }}</el-button>	
					<el-button v-else  round @click="onClickFavorite">{{ interName }}</el-button>
                </p>
            </div>
        </div>
        <!-- <div class="center">
            <img :src="whatsurl" alt="" style="width: 400px;" class="cp" @click="goWhatsapp">
        </div> -->
        <!-- <p class="dflex fcenter print">
            <uwhatsapp></uwhatsapp>
        </p> -->
        <div class="dflex fcenter" :class="$style.last">
            <ubutton :text="$t('back')" @click="backToList"></ubutton>
        </div>
    </div>
</template>
<script>
import heart from '../assets/heart1.svg';
import heartred from '../assets/heartred.svg';
import { format } from 'date-fns';
import reminderDialogVue from '../components/reminderDialog.vue';

// import whatsen from '../assets/whatsen.png';
// import whatszh from '../assets/whatszh.png';
// import jsPDF from 'jspdf';
// import html2canvasExport from './html2canvas';

export default {
    name: 'Detail',
    props: ['code'],
	components: {
		reminderDialogVue,
	},
    data() {
        return {
            item: {
                remark: {},
                family: {},
            },
            pics: ['head_portrait', 'image_a', 'image_b'],
            selectedImg: 'head_portrait',
            // whatsurl: this.$i18n.locale === 'en' ? whatsen : whatszh,
            hoverHeart: false,
            format,
			interName: this.$t('interview'),
			isChecked: false,
			reminderMsg: [
				this.$t('reminderp1'),
				this.$t('reminderp2'),
			],
			requiredDialogVisible: false,
        }
    },
    computed: {
        hearturl() {
            if (this.hoverHeart) {
                return heartred;
            }
            return this.item['is_favorite'] ? heartred : heart;
        },
		// favoriteChecked(){
		// 	return this.item['is_favorite'] == 1 ? true : false;
		// },
        list() {
            return [
                {label: this.$t('code'), value: this.item.code},
                {label: this.$t('name1'), value: this.item.name},
                {label: this.$t('age'), value: this.item.age},
                {label: this.$t('birth'), value: this.item.birthday},
                // {label: this.$t('constellation'), value: this.item.constellation || ''},
                {label: this.$t('zodiac'), value: this.item.zodiac},
                {label: this.$t('marriage'), value: this.item.marriage},
                {label: this.$t('kids'), value: this.item.kids},
                {label: this.$t('st1'), value: this.item['first_love']},
                {label: this.$t('st2'), value: this.item['second_love']},
                {label: this.$t('st3'), value: this.item['third_love']},
                {label: this.$t('religion'), value: this.item['religion']},
            ];
        },
        mobileList() {
            return [
                {label: this.$t('code'), value: this.item.code},
                {label: this.$t('name1'), value: this.item.name},
                {label: this.$t('age'), value: this.item.age},
                {label: this.$t('birth'), value: this.item.birthday},
                // {label: this.$t('constellation'), value: this.item.constellation || ''},
                {label: this.$t('zodiac'), value: this.item.zodiac},
                {label: this.$t('marriage'), value: this.item.marriage},
                {label: this.$t('kids'), value: this.item.kids},
                // {label: this.$t('st1'), value: this.item['first_love']},
                {label: this.$t('religion'), value: this.item['religion']},
                // {label: this.$t('st2'), value: this.item['second_love']},
                {label: '', value: null},
                // {label: this.$t('st3'), value: this.item['third_love']},
            ];
        }
    },
    created() {
        this.$top();
        this.$service.getDetail({code: this.code})
            .then((res) => {
                this.item = res.data;
				this.isChecked = this.item.is_favorite == 1 ? true : false;
            });
    },
    methods: {
        // onClickFavorite() {
        //     this.$service.markFavorite({code: this.item.code}).then(() => {
        //         this.item['is_favorite'] = !this.item['is_favorite'];
        //         this.$forceUpdate();
        //     });
        // },
		closeDialog() {
			this.requiredDialogVisible = false;
		},
		onClickFavorite() {
		    this.$service.markInterview({code: this.item.code}).then(() => {
		        this.item['is_favorite'] = this.item['is_favorite'] == 1 ? 0 : 1;
				this.isChecked = !this.isChecked;
		        this.$forceUpdate();
				if(this.item['is_favorite'] == 1) {
					this.requiredDialogVisible = true;
				}
		    });
		},
        print() {
            window.print();
        },
        handleCommand(command) {
            if (command === 'share')
                this.share();
            else this.washare();
        },
        share() {
            window.open('http://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location.href));
        },
        washare() {
            const t = 'Detail'+this.code;
            const u = window.location.href;
            window.open("https://wa.me/?text="+ encodeURIComponent(t) + encodeURIComponent("\n\n"+u)+"&via=lopscoop");
        },
        pdf() {
            window.open('https://www.goldenwin.com.hk/pdf/'+this.code);
        },
        backToList() {
            // this.$router.push('/search');
			this.$router.go(-1);
        }
    }
}
</script>
<style module>
.lang > p {
    width: 25%;
}
.lang > p:not(:first-child) {
    text-align: center;
}
.lang span {
    display: inline-block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: #ccc;
}
.lang img {
    width: 20px;
    height: 20px;
}
.lang span[selected] {
    background: #484545;
}
.state {
    background: #29bd7a;
}
.state[notavail] {
    background: #ec2626;
}
.wrapper {
    margin: 0px 120px;
    line-height: 1.5;
    font-weight: 440;
}
.wrapper > div {
    margin-bottom: 100px;
}
.wrapper h2 {
    margin-bottom: 20px;
    color: #aaa;
}
.pic > div:first-child {
    margin-right: 50px;
}
.picm {
    margin: 0px 40px;
    width:34%;
}
.heart {
    vertical-align: -3px;
    margin-right:88px;
}
.leftb {
    padding-right:25px;
}
.rightb {
    padding-left:25px;
    word-break: break-all;
}
.last {
    margin-top: 40px;
}
@media screen and (max-width: 770px) {
    .last {
        margin-top: 0px;
    }
  .logos {
    height: 30px;
  }
  .wrapper {
    margin: 0px 20px;
  }
  .wrapper > div {
    margin-bottom: 30px;
    }
    .pic > div:first-child {
    margin-right: 0px;
    }
    .picm {
        margin: 0px;
        width: 70%;
    }
    .full {
        width: 100%;
    }
    .heart {
        vertical-align: -7px;
        margin-right: 30px;
    }
    .leftb {
        padding-right:10px;
    }
    .rightb {
        padding-left:10px;
    }
}
@media print {
    body {
        height: auto;
    }
    .wrapper {
        margin: 0px 40px;
        line-height: 1.4;
    }
    .wrapper > div {
        margin-bottom: 5px;
    }
    .wrapper {
        /* A4宽度 */
        width: 670px;
        margin:0px !important;
        font-size: 14px !important;
    }
    .wrapper h2 {
        margin-bottom: 5px;
    }
}
</style>
